export default __webpack_public_path__ + "static/media/R5C_8027.4ea0b50c.jpg";